import { Construction } from "lucide-react";

/**
 * Placeholder para módulos no migrados todavía.
 * Hace explícito qué falta migrar para que la próxima sesión sepa exactamente
 * dónde meter mano.
 */
export function ModulePlaceholder({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="animate-fade-in">
      <header className="mb-6">
        <h1 className="nx-h1">{title}</h1>
      </header>
      <div className="nx-card p-8 lg:p-10 flex flex-col items-center text-center max-w-2xl mx-auto">
        <div className="w-12 h-12 rounded-full bg-warning-soft text-warning flex items-center justify-center mb-4">
          <Construction size={22} strokeWidth={1.75} />
        </div>
        <h2 className="nx-h2 mb-2">Módulo pendiente de migrar</h2>
        <p className="text-sm text-fg-muted max-w-md">
          Esta sección existe en el Nexus v1 (HTML monolítico). Está agendada para migración en
          una próxima fase del rediseño.
        </p>
        {hint && (
          <div className="mt-4 px-3 py-2 rounded-md bg-bg-subtle border border-border text-xs text-fg-muted font-mono max-w-md">
            {hint}
          </div>
        )}
      </div>
    </div>
  );
}
